import {
  PeopleOutline,
  AttachMoney,
  TrendingUp,
  StraightenOutlined,
  WarningAmber,
} from '@mui/icons-material';
import { MetricCard, type MetricCardProps } from 'finara-components';

interface MetricsGridProps {
  metrics: Record<string, MetricCardProps>;
  className?: string;
}

const getIconForMetric = (key: string) => {
  const iconMap: Record<string, React.ReactNode> = {
    clientesActivos: <PeopleOutline fontSize="inherit" />,
    volumenNomina: <AttachMoney fontSize="inherit" />,
    speiOut: <StraightenOutlined fontSize="inherit" />,
    adelantosActivos: <TrendingUp fontSize="inherit" />,
    saldoTotal: <AttachMoney fontSize="inherit" />,
    errorRate: <WarningAmber fontSize="inherit" />,
  };

  return iconMap[key] ?? <AttachMoney fontSize="inherit" />;
};

export const MetricsGrid: React.FC<MetricsGridProps> = ({
  metrics,
  className = 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[21px]',
}) => {
  return (
    <div className={className}>
      {Object.entries(metrics).map(([key, metric]) => (
        <MetricCard
          key={key}
          title={metric.title}
          value={metric.value}
          description={metric.description}
          trendingUpText={metric.trendingUpText}
          trendingDownText={metric.trendingDownText}
          variant={metric.variant}
          icon={getIconForMetric(key)}
        />
      ))}
    </div>
  );
};
